import { render, staticRenderFns } from "./CleaningHistoryView.vue?vue&type=template&id=1a70cdf4&scoped=true&"
import script from "./CleaningHistoryView.vue?vue&type=script&lang=js&"
export * from "./CleaningHistoryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a70cdf4",
  null
  
)

export default component.exports